var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItsreward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106 109",
    style: {
      enableBackground: "new 0 0 106 109"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F15640;}\r\n\t.st1{fill:#F7B64C;}\r\n\t.st2{fill:#F3715B;}\r\n\t.st3{fill:#FFD15D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_11_",
    className: "st0",
    points: "43.2,42 65.1,42 84.3,23.5 62.4,23.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st1",
    d: "M69.1,51.9h-31V38.3h31L69.1,51.9L69.1,51.9z M41.6,48.4h24v-6.5h-24V48.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7_",
    className: "st2",
    points: "65.1,42 43.2,42 23.8,23.5 45.9,23.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6_",
    className: "st3",
    cx: 53.6,
    cy: 75.5,
    r: 32.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st1",
    d: "M53.6,100.2C40.1,100.2,29,89.1,29,75.5s11.1-24.7,24.7-24.7s24.7,11.1,24.7,24.7 S67.2,100.2,53.6,100.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4_",
    className: "st3",
    points: "53.6,53.3 58.7,68.8 75.1,68.8 61.7,78.5 66.9,94 53.6,84.3 40.4,94 45.5,78.5  32.1,68.8 48.5,68.8  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItsreward);
export default __webpack_public_path__ + "static/media/itsreward.116cbb6ce945cb140dcf9ead72e17303.svg";
export { ForwardRef as ReactComponent };